const CONNECTION_ERROR = 'CONNECTION_ERROR';

const connectionErrorAction = (connectionError) => (dispatch) => {
    dispatch({
        type: CONNECTION_ERROR,
        ...connectionError
    });
};

export default connectionErrorAction;
